import { render, staticRenderFns } from "./Acompanhamento.vue?vue&type=template&id=658c0842&scoped=true&"
import script from "./Acompanhamento.vue?vue&type=script&lang=js&"
export * from "./Acompanhamento.vue?vue&type=script&lang=js&"
import style0 from "./Acompanhamento.vue?vue&type=style&index=0&id=658c0842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658c0842",
  null
  
)

export default component.exports